import HomePage from '../components/Home/Home';

export default function Home() {
  return <HomePage />;
}
